export default __webpack_public_path__ + "8c45277b2038d4c4cc15500e07250dbb.jpg";